import AddCircleIcon from "@mui/icons-material/AddCircle"
import { Box, Button, Container, Grid, Typography, useMediaQuery, useTheme } from "@mui/material"
import { useApi } from "auth/useApi3"
import ClpTable from "components/ClpTable"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import { StyledTableContainer } from "shared/styled/Global"
import IssueReportCategoryForm from "./IssueReportCategoryForm"

import { AppContext } from "components/AppContextProvider"
import TableButton from "components/ClpTable/components/actions/TableButton/TableButton"
import { TableButtonTypeEnum } from "components/ClpTable/components/actions/TableButton/tableButtonProps.interface"
import React, { useContext, useState } from "react"
import { useTranslation } from "react-i18next"

const IssueReportCategorys = () => {
  const { t } = useTranslation()
  const loadingContext = React.useContext(GlobalLoaderContext)
  const appContext = useContext(AppContext)
  const [categoryResult, categoryFuncs] = useApi()
  const theme = useTheme()

  React.useEffect(() => {
    categoryFuncs.get(apiEndpoints.issuereportsadmin.getissuereportcategories)
    return () => {
      categoryFuncs.leave()
    }
  }, [categoryFuncs])

  React.useEffect(() => {
    loadingContext.setLoading(() => categoryResult.status === 1)
  })

  const [editMode, setEditMode] = useState(false)

  // datafetch states and handlers
  // const [listResult, listApi] = useApi();
  const [addResult, addApi] = useApi()
  const [updateResult, updateApi] = useApi()
  const [editItemResult, editItemApi] = useApi()

  // page events from form (after Formik has validated, but the server can still say no so form listens to add/update result state)
  const onAddSubmit = (values) => {
    addApi.post(apiEndpoints.issuereportsadmin.createissuereportcategory, values)
  }
  const onUpdateSubmit = (values) => {
    updateApi.put(apiEndpoints.issuereportsadmin.updateissuereportcategory, values)
  }

  const openEdit = (id) => {
    // show the sidebar in editMode, load any dependant data and pass it along as props
    setEditMode(true)
    appContext.toggleSideBar(true)
    editItemApi.get(apiEndpoints.issuereportsadmin.getissuereportcategorybyid.replace("{id}", id))
    updateApi.reset()
    addApi.reset()
  }

  const openAdd = () => {
    // show sidebar in !editMode, if anything needs to be loaded it also needs to be triggered and passed as prop
    setEditMode(false)
    appContext.toggleSideBar(true)
    editItemApi.reset()
    updateApi.reset()
    addApi.reset()
  }

  React.useEffect(() => {
    loadingContext.setLoading(() => categoryFuncs.status === 1)
  })

  React.useEffect(() => {
    if (updateResult.status === 2 || addResult.status === 2) {
      categoryFuncs.get(apiEndpoints.issuereportsadmin.getissuereportcategories)
      appContext.toggleSideBar(false)
    }
  }, [updateResult, addResult, categoryFuncs])

  const columns = [
    {
      accessorKey: "name",
      header: t("global.table.name", "Name")
    },
    {
      accessorKey: "totalIssueReports",
      header: t("issuereports.number_of_issuereports", "Number of issue reports")
    },
    {
      accessorKey: "edit",
      header: "",
      meta: {
        align: "flex-end"
      },
      cell: ({ cell }) => {
        return (
          <TableButton
            type={TableButtonTypeEnum.Edit}
            handleOnClick={() => {
              openEdit(cell.row.original.id)
            }}
          />
        )
      }
    }
  ]

  const listRows = categoryResult.status === 2 ? categoryResult.data : []
  return (
    <div>
      <Container>
        <IssueReportCategoryForm
          t={t}
          editItemResult={editItemResult}
          addResult={addResult}
          updateResult={updateResult}
          editMode={editMode}
          onAddSubmit={onAddSubmit}
          onUpdateSubmit={onUpdateSubmit}
        />
        <Box>
          <Box
            display="flex"
            flexDirection={useMediaQuery(theme.breakpoints.down("sm")) ? "column" : "row"}
            alignItems={useMediaQuery(theme.breakpoints.down("sm")) ? "flex-start" : "center"}>
            <Box order={2} flexGrow={2}>
              <Grid item>
                <Typography variant="h2">{t("global.categories", "Categories")}</Typography>
                <Typography>
                  {t(
                    "issuereports.administer_categories_for_issuereports",
                    "Administer categories for issue reports"
                  )}
                </Typography>
              </Grid>
            </Box>
            <Grid order={3} mt={{ xs: 2, md: 0 }}>
              <Button
                onClick={() => {
                  openAdd()
                }}
                variant="contained"
                color="primary">
                {t("global.new_category", "New category")}
              </Button>
            </Grid>
          </Box>
        </Box>
      </Container>
      <StyledTableContainer>
        <ClpTable
          columns={columns}
          rows={categoryResult.status === 2 && listRows}
          loadingState={categoryResult.status}
        />
      </StyledTableContainer>
    </div>
  )
}

export default IssueReportCategorys
